export default {
  // 通用接口
  INTERFACE_COMMON_PERIOD_LIST: '/yunkongjianmanager/resource/getPeriod',
  // 获取学段列表
  INTERFACE_COMMON_GRADE_LIST_BY_PERIOD: '/yunkongjianmanager/resource/getGradeByPeriod',
  // 根据学段获取年级列表
  INTERFACE_COMMON_CURRICULUM_LIST_BY_GRADE: '/yunkongjianmanager/resource/getCourseByGrade',
  // 根据年级获取学科列表
  INTERFACE_COMMON_EDITION_LIST_BY_CURRICULUM: '/yunkongjianmanager/resource/getEditionByCourse',
  // 根据学科获取版本列表
  INTERFACE_COMMON_CATALOG_LIST_BY_EDITION: '/yunkongjianmanager/resource/getCatalogByEditionId',
  // 根据版本获取教材目录
  INTERFACE_COMMON_FILE_UPLOAD: '/yunkongjianmanager/file/doUpload',
  // 文件上传
  INTERFACE_COMMON_RESOURCE_TYPE_LIST: '/yunkongjianmanager/resource/getTagInfoList',
  // 获取资源类型列表
  INTERFACE_COMMON_RESOURCE_TYPE_SUPER_LIST: '/yunkongjianmanager/resource/getListBySuperId',
  // 获取资源类型列表

  // 用户相关
  INTERFACE_LOGIN: '/yunkongjianmanager/user/common/doLogin',
  // 登录
  INTERFACE_LOGIN_BY_TICKET: '/yunkongjianmanager/user/common/doLoginByTicket',
  // 登录
  INTERFACE_LOGIN_OUT: '/yunkongjianmanager/user/common/doLogout',
  // 登出
  INTERFACE_GET_USER: '/yunkongjianmanager/user/getUserInfo',
  // 获取用户信息

  // 首页相关
  INTERFACE_PROMOTION_LIST: '/yunkongjianmanager/adInfo/getAdInfoList',
  // 获取广告轮播列表
  INTERFACE_PROMOTION_ADD: '/yunkongjianmanager/adInfo/insertAdInfo',
  // 新增广告轮播
  INTERFACE_PROMOTION_UPDATE: '/yunkongjianmanager/adInfo/updateAdInfo',
  // 编辑广告轮播
  INTERFACE_PROMOTION_OPERATION_DISABLE: '/yunkongjianmanager/adInfo/downAdInfo',
  // 下架广告轮播
  INTERFACE_PROMOTION_OPERATION_ABLE: '/yunkongjianmanager/adInfo/upAdInfo',
  // 上架广告轮播
  INTERFACE_PROMOTION_OPERATION_DELETE: '/yunkongjianmanager/adInfo/delAdInfo',
  // 删除广告轮播
  // 资源类型管理相关
  INTERFACE_RESOURCE_TYPE_LIST: '/yunkongjianmanager/tag/getTagInfoList',
  // 获取资源类型列表
  INTERFACE_RESOURCE_TYPE_ADD: '/yunkongjianmanager/tag/insertTagInfo',
  // 新增资源类型
  INTERFACE_RESOURCE_TYPE_UPDATE: '/yunkongjianmanager/tag/updateTagInfo',
  // 编辑资源类型
  INTERFACE_RESOURCE_TYPE_DELETE: '/yunkongjianmanager/tag/delTagInfo',
  // 删除资源类型
  // 资源年级管理相关
  INTERFACE_RESOURCE_GRADE_LIST: '/yunkongjianmanager/resource/getReSourceGradeList',
  // 获取资源年级管理列表
  INTERFACE_RESOURCE_GRADE_ADD: '/yunkongjianmanager/resource/insertGrade',
  // 新增资源年级
  INTERFACE_RESOURCE_GRADE_UPDATE: '/yunkongjianmanager/resource/updateGrade',
  // 编辑资源年级
  INTERFACE_RESOURCE_GRADE_DELETE: '/yunkongjianmanager/resource/delGrade',
  // 删除资源年级
  // 资源学科管理相关
  INTERFACE_RESOURCE_CURRICULUM_LIST: '/yunkongjianmanager/resource/getReSourceCourseList',
  // 获取学科列表
  INTERFACE_RESOURCE_CURRICULUM_ADD: '/yunkongjianmanager/resource/insertCourse',
  // 新增学科
  INTERFACE_RESOURCE_CURRICULUM_UPDATE: '/yunkongjianmanager/resource/updateCourse',
  // 编辑学科
  INTERFACE_RESOURCE_CURRICULUM_DELETE: '/yunkongjianmanager/resource/delCourse',
  // 删除学科
  // 资源版本管理相关
  INTERFACE_RESOURCE_EDITION_LIST: '/yunkongjianmanager/resource/getReSourceEditionList',
  // 获取版本列表
  INTERFACE_RESOURCE_EDITION_ADD: '/yunkongjianmanager/resource/insertEdition',
  // 新增版本
  INTERFACE_RESOURCE_EDITION_UPDATE: '/yunkongjianmanager/resource/updateEdition',
  // 编辑版本
  INTERFACE_RESOURCE_EDITION_DELETE: '/yunkongjianmanager/resource/delEdition',
  // 删除版本
  INTERFACE_RESOURCE_CATALOG_EXPORT: '/yunkongjianmanager/resource/exportByEditionId',
  // 根据版本ID导出教材目录
  INTERFACE_RESOURCE_CATALOG_GET: '/yunkongjianmanager/resource/getCatalogByEditionId',
  // 根据版本ID查看教材目录

  // 用户资源管理
  INTERFACE_RESOURCE_PRIVATE_LIST: '/yunkongjianmanager/resource/getUserReSourceList',
  // 获取用户资源管理列表
  INTERFACE_RESOURCE_PRIVATE_REPORT: '/yunkongjianmanager/resource/synUserReSource',
  // 用户资源同步、取消同步
  INTERFACE_RESOURCE_PRIVATE_HIDDEN: '/yunkongjianmanager/resource/showOrHideUserReSource',
  // 用户资源隐藏、取消隐藏
  INTERFACE_RESOURCE_PRIVATE_DELETE: '/yunkongjianmanager/resource/delUserReSource',
  // 用户资源删除
  INTERFACE_RESOURCE_PRIVATE_DETAIL: '/yunkongjianmanager/resource/getUserReSourceById',
  // 获取用户资源详情
  INTERFACE_RESOURCE_PRIVATE_COMMENT_LIST: '/yunkongjianmanager/resource/getResourceCommentsByUserResourceId',
  // 获取用户资源评论列表
  INTERFACE_RESOURCE_PRIVATE_COMMENT_DELETE: '/yunkongjianmanager/resource/delCommentById',
  // 删除评论信息
  INTERFACE_RESOURCE_PRIVATE_CATALOG_LIST: '/yunkongjianmanager/resource/getCatalogByUserResourceId',
  // 获取用户资源ID获取教材目录
  INTERFACE_RESOURCE_PRIVATE_UPDATE: '/yunkongjianmanager/resource/updateUserResourceInfo',
  // 编辑用户资源
  // 公共资源管理
  INTERFACE_RESOURCE_PUBLIC_LIST: '/yunkongjianmanager/resource/getCommonReSourceList',
  // 获取公共资源列表
  INTERFACE_RESOURCE_PUBLIC_REPORT: '/yunkongjianmanager/resource/synCommonReSource',
  // 公共资源同步、取消同步
  INTERFACE_RESOURCE_PUBLIC_HIDDEN: '/yunkongjianmanager/resource/showOrHideCommonReSource',
  // 公共资源隐藏、取消隐藏
  INTERFACE_RESOURCE_PUBLIC_DELETE: '/yunkongjianmanager/resource/delCommonReSource',
  // 公共资源删除
  INTERFACE_RESOURCE_PUBLIC_DETAIL: '/yunkongjianmanager/resource/getCommonReSourceById',
  // 获取公共资源详情
  INTERFACE_RESOURCE_PUBLIC_COMMENT_LIST: '/yunkongjianmanager/resource/getResourceCommentsByCommonResourceId',
  // 获取用户公共评论列表
  INTERFACE_RESOURCE_PUBLIC_CATALOG_LIST: '/yunkongjianmanager/resource/getCatalogByCommonResourceId',
  // 获取公共资源ID获取教材目录
  INTERFACE_RESOURCE_PUBLIC_UPDATE: '/yunkongjianmanager/resource/updateCommonResourceInfo',
  // 编辑公共资源
  INTERFACE_RESOURCE_PUBLIC_EXAMINE: '/yunkongjianmanager/resource/updateCommonResourceInfoApplyStatus',
  // 审核上报资源

  // 社区相关
  INTERFACE_COMMUNITY_POST_QUESTION_LIST: '/yunkongjianmanager/communityManager/listPosts',
  // 获取帖子或问答列表
  INTERFACE_COMMUNITY_POST_QUESTION_OPERATION: '/yunkongjianmanager/communityManager/operatePosting',
  // 帖子或问答的隐藏或删除
  INTERFACE_COMMUNITY_POST_QUESTION_DETAIL: '/yunkongjianmanager/communityManager/getPostingById',
  // 获取帖子或问答详情
  INTERFACE_COMMUNITY_POST_QUESTION_LIST_COMMENT: '/yunkongjianmanager/communityManager/repliesList',
  // 获取帖子或问答评论列表
  INTERFACE_COMMUNITY_POST_QUESTION_LIST_REPLY: '/yunkongjianmanager/communityManager/getReplyOutsById',
  // 获取帖子或问答评论的回复列表
  INTERFACE_COMMUNITY_POST_QUESTION_DELETE_REPLY: '/yunkongjianmanager/communityManager/deleteRepliesByIds',
  // 删除帖子或问答的评论或者评论回复
  INTERFACE_COMMUNITY_POST_U_CHOICE_LIST: '/yunkongjianmanager/communityManager/getPostingPriorityList',
  // 获取帖子优选参数
  INTERFACE_COMMUNITY_POST_U_CHOICE_UPDATE: '/yunkongjianmanager/communityManager/settingPostingPriority',
  // 设置帖子优选参数
  INTERFACE_COMMUNITY_TAG_LIST: '/yunkongjianmanager/communityManager/listTags',
  // 获取标签列表
  INTERFACE_COMMUNITY_TAG_OPERATION: '/yunkongjianmanager/communityManager/editTags',
  // 标签操作
  // 用户管理
  INTERFACE_USER_COMPLAINT_LIST: '/yunkongjianmanager/userManager/getInformLists',
  // 获取举报审核列表
  INTERFACE_USER_COMPLAINT_DETAIL: '/yunkongjianmanager/userManager/getInformDetails',
  // 获取举报审核详情
  INTERFACE_USER_COMPLAINT_APPROVE: '/yunkongjianmanager/userManager/handlingInformById',
  // 审核
  INTERFACE_USER_FRONT_LIST: '/yunkongjianmanager/userManager/listUsers',
  // 获取平台用户列表
  INTERFACE_USER_SCHOOL_LIST: '/yunkongjianmanager/userManager/getSchoolsLists',
  // 获取学校列表
  INTERFACE_USER_RIGHT_UPDATE: '/yunkongjianmanager/userManager/editUserRights',
  // 编辑用户权限
  INTERFACE_USER_ACCOUNT_UPDATE: '/yunkongjianmanager/userManager/forbiddenSomebody',
  // 禁用、启用、删除
  INTERFACE_USER_ACCOUNT_RESET_PASSWORD: '/yunkongjianmanager/userManager/resetPassword',
  // 重置密码
  INTERFACE_USER_BACK_RIGHT_LIST: '/yunkongjianmanager/userManager/getBackGroundUserRightsTypeLists',
  // 获取后台权限列表
  INTERFACE_USER_ADD_USER: '/yunkongjianmanager/userManager/convertToBackgroundUser',
  // 添加新用户
  INTERFACE_USER_SCHOOL_LIST_BY_NAME: '/yunkongjianmanager/userManager/searchSchoolsLists',
  // 根据名称获取学校列表
  INTERFACE_USER_LIST_BY_SCHOOL: '/yunkongjianmanager/userManager/getUserListBySchoolId',
  // 根据学校ID获取手机号和姓名
  // 系统管理相关
  INTERFACE_SYSTEM_PLATFORM_LIST: '/yunkongjianmanager/systemManager/listPlatformMsg',
  // 获取平台信息管理列表
  INTERFACE_SYSTEM_PLATFORM_ADD: '/yunkongjianmanager/systemManager/insertPlatformMsg',
  // 添加平台信息管理
  INTERFACE_SYSTEM_PLATFORM_UPDATE: '/yunkongjianmanager/systemManager/editPlatformMsg',
  // 更新平台信息管理
  INTERFACE_SYSTEM_LOG_LIST: '/yunkongjianmanager/systemManager/getOperateLogList',
  // 获取平台日志列表
  //新闻
  INTERFACE_NEWS_LIST: '/yunkongjianmanager/newsInfo/getNews',
  // 获取新闻列表
  INTERFACE_NEWS_ADDNEWS: '/yunkongjianmanager/newsInfo/insertNews',
  // 新增新闻
  INTERFACE_NEWS_EDITNEWS: '/yunkongjianmanager/newsInfo/updateNews',
  // 编辑新闻
  INTERFACE_NEWS_NEWSDETAIL: '/yunkongjianmanager/newsInfo/getNewsById',
  // 获取新闻详情
  INTERFACE_NEWS_TOPNEWS: '/yunkongjianmanager/newsInfo/topNewsById',
  // 置顶或取消置顶
  INTERFACE_NEWS_HIDENEWS: '/yunkongjianmanager/newsInfo/enableNewsById',
  // 隐藏或取消隐藏
  INTERFACE_NEWS_DELETENEWS: '/yunkongjianmanager/newsInfo/delNewsById',
  // 删除新闻
  //名师工作室
  INTERFACE_GET_STUDIO_APPLY_LIST: '/yunkongjianmanager/studioManager/listStudioApplication',
  // 获取工作室申请列表
  INTERFACE_GET_STUDIO_APPLY_DETAIL: '/yunkongjianmanager/studioManager/getStudioApplication',
  // 通过id获取工作室详情
  INTERFACE_POST_STUDIO_APPLY_AUDIT: '/yunkongjianmanager/studioManager/auditOneApply',
  //审核
  INTERFACE_POST_STUDIO_APPLY_EDIT: '/yunkongjianmanager/studioManager/updateStudioApplicationType',
  //编辑
  //教材
  INTERFACE_GET_DATA_BY_TYPE_ID: '/yunkongjianmanager/resource/getDataByTypeId',
  //根据学段获取学科，学科获取版本，版本获取年级接口 type_id为0表示获取本单位所有学段
  INTERFACE_POST_TEXTBOOK_ADD: '/yunkongjianmanager/resource/insertResourceUnitCategory',
  //设置本校教材目录接口
  INTERFACE_POST_TEXTBOOK_EDIT: '/yunkongjianmanager/resource/updateResourceUnitCategory',
  //编辑本校教材目录接口
  INTERFACE_GET_TEXTBOOK_LIST: '/yunkongjianmanager/resource/getResourceUnitCategoryList',
  //列表
  INTERFACE_POST_TEXTBOOK_DEL: '/yunkongjianmanager/resource/delResourceUnitCategoryById' //删除
};